function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ResidentialListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { RangeSearchQueryField } from '../range-search-query-field';
import { Range } from '../range';
export class BedsFilter extends RangeSearchQueryField {
  constructor() {
    super(...arguments);
    _defineProperty(this, "urlSlug", BedsFilter.urlSlug);
  }
  get validListingTypes() {
    return [...ResidentialListingTypeKeys, 'DEVELOPMENTS_RESIDENTIAL'];
  }
  static fromUrlParameters(searchOptions, q, p) {
    return new BedsFilter(searchOptions, Range.fromUrlParameter(q[BedsFilter.urlSlug] || p.beds));
  }
}
_defineProperty(BedsFilter, "urlSlug", 'beds');